import ApiService from "../ApiService";
import axios from "axios";
import store from '../../store/index';

const accessToken = store.state.auth.token;

const UserService = {
    async register(data) {
        console.log("x1 data", data);
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/`,
            method: "POST",
            data: data,
            headers: {
                "Content-Type": "multipart/form-data; boundary=${form._boundary}"
            }
        });
    },
    async existencia(data) {
        //?identification=${identification}
        console.log("idee", data)
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/isEmailExist?id=${data}`,
            method: "GET",

        });
    },

    async recoveryToken(email) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/recoveryToken`,
            method: "POST",
            data: { email: email }
        });
    },

    async verifyRecoveryToken(data) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/verifyToken`,
            method: "POST",
            data: data
        });
    },

    async saveProfile(data) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/saveProfile`,
            method: "POST",
            data: data
        });
    },

    async passwordRecovery(body) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/passwordRecovery`,
            method: "POST",
            data: body
        });
    },

    async getOne(body) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/getOne`,
            method: "POST",
            data: body
        });
    },

    async documentTypes() {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/identification-type`,
            method: "GET"
        });
    },

    async prioritizedPatient(identification, identificationType) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/prioritized-patient?identification=${identification}&identificationType=${identificationType}`,
            method: "GET",
            headers: {
                "Authorization": accessToken
            }
        });
    },
    async saveFileTemp(formData) {
        return await ApiService.customRequest({
            url: `https://shemanagmentstorage.azurewebsites.net/api/blob/upload/temp`,
            method: "POST",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Credentials": "true",
                "Access-Control-Allow-Origin": "*"
            }
        });
    },
    async updateProfileFile(userId, imageData) {
        return axios.put(`/patient-credential/${userId}/update-avatar`, imageData);
    },
    async searchTemporal(identification) {
        return await ApiService.customRequest({
            url: `https://qa-helpharma-p2h-apigateway-back.azurewebsites.net/user-app/searchTemporal?page=0&perPage=10&identification=${identification}`,
            method: "GET",
            headers: {
                "Access-Control-Allow-Credentials": "true",
                "Access-Control-Allow-Origin": "*"
            }
        });
    },
    async searchTemporal2(identification) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/searchTemporal?page=0&perPage=10&identification=${identification}`,
            method: "GET"
        });
    },
    async approveTemporal(user) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/approveTemporal`,
            method: "POST",
            data: user
        });
    },
    async denyTemporal(user) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/user-app/denyTemporal`,
            method: "POST",
            data: user
        });
    },
    async barcodeverify(formData) {
        return await ApiService.customRequest({
            url: `https://qa-helpharma-p2h-barcode-verify-back.azurewebsites.net/api/V1/codebar/upload`,
            //url: `${ApiService.farmadomiciliosApiURL}/user-app/barcodeverify`,
            method: "POST",
            data: formData
        });
    },
    async SendEmail(body) {
        return await ApiService.customRequest({
            url: `${process.env.VUE_APP_BACK}/user-app/sendEmailP2H`,
            //url: `https://qa-helpharma-p2h-barcode-verify-back.azurewebsites.net/api/V1/codebar/upload`,
            method: "POST",
            data: body
        });
    }
};

export default UserService;